import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DialogService } from 'rev-shared/ui/dialog/Dialog.Service';
import { IConfirmationDialogActionData } from 'rev-shared/ui/dialog/IConfirmationDialogActionData';
import { IWebcastViewContext } from 'rev-shared/webcast/webcastView/IWebcastViewContext';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { TranslateModule } from '@ngx-translate/core';
import { VbConfirmationDialogComponent } from 'rev-shared/ui/dialog/VbConfirmationDialogAngular.Component';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';

import { WebcastViewQuestionsService } from './WebcastViewQuestions.Service';
import { Question } from './Question';

let cardIndexCounter = 0;

@Component({
	selector: 'vb-webcast-question-manage-card',
	templateUrl: './VbWebcastQuestionManageCard.Component.html',
	standalone: true,
	imports: [
		BsDropdownModule,
		ButtonsAngularModule,
		CommonModule,
		DialogAngularModule,
		PipesAngularModule,
		TranslateModule,
		VbProfilePictureModule
	],
	styleUrls: ['./VbWebcastQuestionCard.ng.less', '../WebcastSidebar.ng.less']
})
export class VbWebcastQuestionManageCardComponent {
	@Input() public context: IWebcastViewContext;
	@Input() public webcastId: string;
	@Input() public question: Question;
	@Input() public canModerate: boolean;
	@Input() public allowReordering: boolean;
	public cardIndex: number = cardIndexCounter++;

	@ViewChild(VbConfirmationDialogComponent)
	public replyInProgressActionConfirmation: VbConfirmationDialogComponent;

	constructor(
		private readonly DialogService: DialogService,
		private readonly WebcastViewQuestionsService: WebcastViewQuestionsService
	) {}

	public addToQueue(): void {
		this.confirmReplyConflict()
			.then(() => {
				this.WebcastViewQuestionsService.addQuestionToQueue(this.webcastId, this.question);
			});
	}

	public close(): void {
		this.confirmReplyConflict()
			.then(() => {
				this.WebcastViewQuestionsService.closeQuestion(this.webcastId, this.question);
			});
	}

	public followUp(): void {
		this.confirmReplyConflict()
			.then(() => {
				this.WebcastViewQuestionsService.followUpQuestion(this.webcastId, this.question);
			});
	}

	public answered(): void {
		this.confirmReplyConflict()
			.then(() => {
				this.WebcastViewQuestionsService.answeredQuestion(this.webcastId, this.question);
			});
	}

	public decline(): void {
		this.confirmReplyConflict()
			.then(() => {
				this.WebcastViewQuestionsService.declineQuestion(this.webcastId, this.question);
			});
	}

	public directReply(): void {
		this.confirmReplyConflict()
			.then(() => {
				//signal to other moderaters that a reply is being written
				this.WebcastViewQuestionsService.startDirectReplyQuestion(this.webcastId, this.question)
					.then(() => {
						this.DialogService
							.getDialog('vbWebcastQuestionDirectReply')
							.open({
								initialState: {
									question: this.question,
									webcastId: this.webcastId,
									context: this.context
								},
								class: 'dialog-shell-style'
							});
					});
			});
	}

	private confirmReplyConflict(): Promise<void | IConfirmationDialogActionData> {
		if (this.question.isDirectReplyInProgress) {
			return this.replyInProgressActionConfirmation.open().result;
		}
		return Promise.resolve();
	}
}
